/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SubCategory {
  BAGGAGE = 'baggage',
  OVERSIZED_BAGGAGE = 'oversizedBaggage',
  CHECKED_BAGGAGE = 'checkedBaggage',
  CHECKED_BAGGAGE_NON_AY = 'checkedBaggageNonAy',
  CABIN_BAGGAGE = 'cabinBaggage',
  CABIN_BAGGAGE_NON_AY = 'cabinBaggageNonAy',
  CABIN_ITEM = 'cabinItem',
  CABIN_INFANT = 'cabinInfant',
  CABIN_WEIGHT = 'cabinWeight',
  MEAL = 'meal',
  SPECIAL_DIET = 'specialDiet',
  SEAT = 'seat',
  WIFI = 'wifi',
  LOUNGE = 'lounge',
  MEDICAL = 'medical',
  ASSISTANCE = 'assistance',
  PETS = 'pets',
  TRAVEL_COMFORT = 'travelComfort',
  COVER = 'cover',
  OTHER = 'other',
  PET_IN_HOLD = 'petInHold',
  PET_IN_CABIN = 'petInCabin',
  BIKE = 'bike',
  WINDSURFING = 'windsurfing',
  SKIS = 'skis',
  SKI_JUMPING = 'skiJumping',
  SPORTS_MEDIUM = 'sportsMedium',
  SPORTS_LARGE = 'sportsLarge',
  HOCKEY = 'hockey',
  GOLF = 'golf',
  SURF = 'surf',
  TIER_BENEFIT_SPORT_EQUIPMENT = 'tierBenefitSportEquipment',
  TANDEM_BIKE = 'tandemBike',
  VAULTING_POLE = 'vaultingPole',
  SPECIAL_EQUIPMENT = 'specialEquipment',
  MUSICAL_MEDIUM = 'musicalMedium',
  MUSICAL_LARGE = 'musicalLarge',
  MEDIA = 'media',
  HEAVY_OR_LARGE = 'heavyOrLarge',
  FIREARM = 'firearm',
  AMMUNITION = 'ammunition',
  OXYGEN = 'oxygen',
  ASSISTANCE_ITEMS = 'assistanceItems',
  ASSISTANCE_SERVICES = 'assistanceServices',
  CHILD_ASSISTANCE = 'childAssistance',
  FRESH_MEAL = 'freshMeal',
  HOT_PRE_ORDER_MEAL = 'hotPreOrderMeal',
  EMOTIONAL_SUPPORT_ANIMAL = 'emotionalSupportAnimal',
  FAST_TRACK = 'fastTrack',
  PRIORITY_SERVICES = 'priorityServices',
  SAF_LOW = 'safLow',
  SAF_MID = 'safMid',
  SAF_HIGH = 'safHigh',
  SEAT_WIFI = 'seatWifi',
  SEAT_HOT_PRE_ORDER_MEAL = 'seatHotPreOrderMeal',
  SEAT_FRESH_MEAL = 'seatFreshMeal',
  SEAT_CABIN_BAGGAGE = 'seatCabinBaggage',
  SEAT_PRIORITY_SERVICES = 'seatPriorityServices',
  WIFI_FRESH_MEAL = 'wifiFreshMeal',
  WIFI_HOT_PRE_ORDER_MEAL = 'wifiHotPreOrderMeal',
  LOUNGE_CABIN_BAGGAGE = 'loungeCabinBaggage',
  LOUNGE_PRIORITY_SERVICES = 'loungePriorityServices',
  LOUNGE_WIFI = 'loungeWifi'
}

